import { PointType, } from "../site/arbitrary-line/types";
/**
 * Generate cross-section points at the centerline points of an alignment or SIMA.
 * Each point takes its direction from the line and reuses the line's sphere entity.
 *
 * @throws Error if the line has fewer than 2 points
 */
export function generateCenterlineCrossSectionPoints(line, setting) {
    const crossSectionPoints = [];
    const stationPoints = line.pointsToCreateCrossSection;
    if (stationPoints.length < 2) {
        throw new Error("Insufficient points for alignment");
    }
    for (let i = 0; i < stationPoints.length; ++i) {
        const currentPoint = stationPoints[i];
        const direction = line.getDirectionAtCenterlinePoint(currentPoint.id);
        if (!direction) {
            continue;
        }
        crossSectionPoints.push({
            id: currentPoint.id,
            lineID: line.id,
            pointType: PointType.STATION_POINT,
            label: currentPoint.label,
            wgs84data: {
                sphere: line.getCesiumSphereEntity(currentPoint.id),
                label: null,
            },
            leftOutlineData: {
                direction: direction.left,
                distance: setting.leftWidth,
            },
            rightOutlineData: {
                direction: direction.right,
                distance: setting.rightWidth,
            },
            position: currentPoint.point,
            sampleSize: setting.samplingSize,
        });
    }
    // Get pathInfo data from the line
    // if (line.points.length < 2) {
    // 	throw new Error("Insufficient points for alignment");
    // }
    // let allCrossSectionPoints: ProcessedCrossSectionPoint[] = [];
    // 	const interpolationPitch = setting.interpolationPitch;
    // // Validate output
    // if (allCrossSectionPoints.length < 2) {
    // 	throw new Error(
    // 		"Alignment-based logic generated insufficient points for cross-section",
    // 	);
    // }
    // return allCrossSectionPoints;
    return crossSectionPoints;
}
//# sourceMappingURL=centerline-cross-section-points.js.map